"use client";

import { motion, useReducedMotion } from "framer-motion";

export function FloatingShapes() {
  const prefersReducedMotion = useReducedMotion();
  const shapes = [
    { size: 300, x: "10%", y: "20%", delay: 0, duration: 6 },
    { size: 200, x: "80%", y: "30%", delay: 1, duration: 8 },
    { size: 150, x: "60%", y: "70%", delay: 2, duration: 7 },
    { size: 100, x: "20%", y: "80%", delay: 3, duration: 9 },
    { size: 250, x: "90%", y: "60%", delay: 0.5, duration: 10 },
  ];

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {shapes.map((shape, index) => (
        <motion.div
          key={index}
          className="absolute rounded-full bg-gradient-to-br from-primary/20 to-accent/20 dark:from-primary/10 dark:to-accent/10 blur-3xl"
          style={{
            width: shape.size,
            height: shape.size,
            left: shape.x,
            top: shape.y,
          }}
          animate={
            prefersReducedMotion
              ? {}
              : {
                  y: [0, -30, 0],
                  x: [0, 20, 0],
                  scale: [1, 1.1, 1],
                }
          }
          transition={
            prefersReducedMotion
              ? { duration: 0 }
              : {
                  duration: shape.duration,
                  delay: shape.delay,
                  repeat: Infinity,
                  ease: "easeInOut",
                }
          }
        />
      ))}
    </div>
  );
}
